(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["popup-newsletter"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const popup = document.getElementById('popup-newsletter__modal');

    if (!popup) return;

    // Check subscription flag
    const subscribed = localStorage.getItem('popup_subscribed');

    if (subscribed === 'true') {
      popup.style.display = 'none';
      document.body.classList.remove('xo-modal-open'); // just in case
      document.body.style.overflow = 'auto';
      return;
    }

    // Listen for newsletter form submit
    document.addEventListener('submit', function (e) {
      if (e.target && (e.target.id === 'ContactFooter' || e.target.classList.contains('newsletter-form'))) {
        localStorage.setItem('popup_subscribed', 'true');
        popup.style.display = 'none';
        document.body.classList.remove('xo-modal-open'); // just in case
        document.body.style.overflow = 'auto';
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
